import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-broken-image-icon',
    templateUrl: './broken-image-icon.component.html',
    styleUrls: ['./broken-image-icon.component.css'],
    standalone: false
})
export class BrokenImageIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
};
